import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./datatablesource";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { deleteEntity } from "../../components/supabae/SupabaseDeleteEntity"; // Import the script


const Datatable = () => {
  const [data, setData] = useState([]);
  const [idToDelete, setIdToDelete] = useState("");
  const [open, setOpen] = useState(false); // State for the modal

  // Fetch data from Firestore
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "doctors"), // Specify the collection
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, []);

  // Handle delete button click
  const handleDeleteClick = (id) => {
    setIdToDelete(id); // Set the ID of the item to delete
    setOpen(true); // Open the confirmation modal
  };

  // Handle closing the modal
  const handleClose = () => {
    setOpen(false);
    setIdToDelete(""); // Reset the id to delete
  };

  // Handle deletion
// Handle deletion
const handleDelete = async () => {
  if (!idToDelete) {
    console.error("ID to delete is missing");
    return;
  }

  try {
    // Step 1: Delete document from Firestore
    await deleteDoc(doc(db, "doctors", idToDelete));
    console.log("Document deleted from Firestore");

    // Step 2: Delete the entity from Supabase
    const deletedEntity = await deleteEntity(idToDelete);
    if (deletedEntity) {
      console.log("Entity deleted from Supabase");
    }

    // Remove the deleted item from the state (UI)
    setData(data.filter((item) => item.id !== idToDelete));
  } catch (err) {
    console.error("Error deleting document:", err);
  } finally {
    handleClose(); // Close the modal after deletion
  }
};


  // Columns for the DataGrid
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/doctors/fullview?uid=${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDeleteClick(params.row.id)} // Trigger delete confirmation modal
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        Doctors
        <Link to="/doctors/new" className="link">
          Add New
        </Link>
      </div>

      {/* DataGrid for displaying doctor data */}
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)} // Combine your columns with action column
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />

      {/* Confirmation Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this document? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Datatable;
